import React from "react";

function CustomLoader() {
  return (
    <div>
      <div className="bouncing-loader">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
}

export default CustomLoader;
